import React from "react";
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { buildWaLinkGeneric, WA_NUMBER_LOCAL } from "../lib/whatsapp";
import { useCompare } from "../lib/compareStore";

export default function WhatsappFab() {
  const { slugs } = useCompare();
  const link = buildWaLinkGeneric(
    "Halo, saya baru melihat website Anda dan ingin konsultasi motor Yamaha."
  );
  // FAB dinaikkan tinggi supaya aman dari badge Netlify. Naik lebih tinggi lagi saat compare-bar aktif agar tidak menabrak.
  const bottomCls = slugs.length > 0 ? "bottom-44 sm:bottom-40" : "bottom-20 sm:bottom-20";

  return (
    <motion.a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="wa-fab"
      aria-label={`Chat WhatsApp ${WA_NUMBER_LOCAL}`}
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 0.6, type: "spring", stiffness: 260, damping: 20 }}
      whileHover={{ scale: 1.06 }}
      whileTap={{ scale: 0.95 }}
      className={`wa-pulse fixed ${bottomCls} right-4 sm:right-5 z-50 inline-flex items-center gap-2 px-3.5 py-2.5 rounded-full bg-[#25D366] text-white shadow-2xl hover:bg-[#1ebe57] transition-all`}
    >
      <MessageCircle className="w-4 h-4 sm:w-5 sm:h-5" />
      <span className="hidden sm:inline font-semibold text-sm">Chat Sekarang</span>
    </motion.a>
  );
}
